<app-ptrab-two-factor-card
  title="TWO_FACTOR.SET_CODE.WRITE_CODE"
  imageSrc="assets/imgs/employee-portal/codigo_sms.svg"
  [buttons]="buttons()">
  <div class="code-card__content">
    <span class="code-card__text" [innerHtml]="'TWO_FACTOR.SET_CODE.INFO' | mTranslate"></span>

    @if (showCodeValidationForm()) {
      <form class="code-card__code" [formGroup]="form">
        <app-code-input
          formControlName="code"
          [length]="codeLength"
          [invalid]="isCodeInvalid()"
          [label]="'TWO_FACTOR.TYPE_CODE.KEY' | mTranslate"
          (keydown.enter)="isCodeComplete() && validateCode()" />

        @if (isCodeInvalid()) {
          <span class="code-card__error">
            <m-icon iconName="alertTriangleRegular" />
            {{ 'TWO_FACTOR.TYPE_CODE.INCORRECT' | mTranslate }}
          </span>
        }
      </form>
    }

    @if (maxTriesExceeded()) {
      <m-banner
        type="alert"
        [titleLabel]="'TRIES_EXCEEDED.TITLE' | mTranslate"
        [description]="'TRIES_EXCEEDED.MESSAGE' | mTranslate" />
    }
    @if (expiredCode()) {
      <m-banner
        type="warning"
        [titleLabel]="'TWO_FACTOR.EXPIRED_CODE.TITLE' | mTranslate"
        [description]="'TWO_FACTOR.EXPIRED_CODE.INFO' | mTranslate" />
    }
    @if (!maxTriesExceeded()) {
      <div class="code-card__code">
        <span class="code-card__text">{{ 'TWO_FACTOR.SET_CODE.CODE_NOT_RECEIVED' | mTranslate }}</span>
        <div class="code-card__resend">
          <a m-link data-testid="code-resend-link" [disabled]="!sendAgainAvailable()" (m-click)="resendCode()">
            {{ 'TWO_FACTOR.SET_CODE.SEND_CODE' | mTranslate }}
          </a>

          @if (!sendAgainAvailable()) {
            <span class="code-card__timer">
              {{ 'TWO_FACTOR.SET_CODE.SEND_CODE_TIMER' | mTranslate }}
              {{ timeRemaining() | date: 'mm:ss' }}
            </span>
          }
        </div>
      </div>
    }
  </div>
</app-ptrab-two-factor-card>
